// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .tour_details___wrapper{hyphens:manual}.eopoi-widget .tour_details___wrapper p{text-indent:-1.5em;margin-left:1.5em}.eopoi-widget .tour_details___wrapper p span{display:inline-block;width:1.5em;text-indent:0}.tour_details___wrapper p span.v-tooltip{display:block}", ""]);
// Exports
module.exports = exports;
